import './About.css';
import content from '../data/content.json';

const About: React.FC = () => {
  return (
    <section className="about" id="sobre">
      <div className="container">
        <h2>{content.about.title}</h2>
        <div className="about-content">
          <p className="lead">
            {content.about.leadText}
          </p>
          <p>
            {content.about.description}
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
